import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as SurprisedBuddy } from '../../../../../assets/icons/buddy-surprised.svg';
import { TRANSLATIONS_GLOBAL } from '../../../../translations/commons';
import BdsModal from '../../Modals/BdsModal/BdsModal';

interface ChangeCompanyWarningModalProps {
  open: boolean;
  companyName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ChangeCompanyWarningModal = ({ open, companyName, onConfirm, onCancel }: ChangeCompanyWarningModalProps) => {
  const { t } = useTranslation();
  const { changeWarning } = TRANSLATIONS_GLOBAL.header.companySelector;

  return (
    <BdsModal
      open={open}
      icon={<SurprisedBuddy />}
      title={t(changeWarning.title, { company: companyName })}
      description={t(changeWarning.description)}
      onClose={onCancel}
      onBackdropClick={onCancel}
      primaryAction={{ label: t(changeWarning.confirm), onClick: onConfirm }}
      secondaryAction={{ label: t(changeWarning.cancel), onClick: onCancel }}
    />
  );
};

export default ChangeCompanyWarningModal;
